import * as React from 'react'
import { Image, TouchableOpacity, View } from 'react-native'
import styled from '@theme/styled-components'
import Theme from '@theme/Theme'

import Icon from '@components/icon/Icons'
import Hoverable from '@components/hover/Hoverable'

interface Props {
  data: string
  onDelete: () => void
  size: number
  mode?: 'contain' | 'cover'
  dark?: boolean
}

const DeletablePicture = ({ data, onDelete, size, mode = 'cover', dark }: Props) => {
  const [hover, setHover] = React.useState(false)

  return (
    <Hoverable onHover={setHover}>
      <TouchableOpacity activeOpacity={0.9} onPress={onDelete}>
        <Picture source={{ uri: data }} resizeMode={mode} size={size} />

        {hover && (
          <Delete size={size} dark={dark}>
            <Icon name="delete" size={size / 6} color={Theme.colors.background} />
          </Delete>
        )}
      </TouchableOpacity>
    </Hoverable>
  )
}

export default DeletablePicture

const Picture = styled(Image)<{ size: number }>`
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
`

const Delete = styled(View)<{ size: number; dark?: boolean }>`
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  position: absolute;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => `${props.dark ? props.theme.colors.primaryText : props.theme.colors.background}33`};
`
